import gql from 'graphql-tag'

export const UPDATE_LANGUAGE = gql`
  mutation updateLanguage($language: String) {
    updateLanguage(language: $language) {
      defaultLocale
    }
  }
`
